// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDuCtKvfvZXjaJy7bwVWhWeAIfqiPkz4GY",
    authDomain: "ptskart-8850e.firebaseapp.com",
    projectId: "ptskart-8850e",
    storageBucket: "ptskart-8850e.firebasestorage.app",
    messagingSenderId: "815030125915",
    appId: "1:815030125915:web:0ce1171634966c7e46867e",
    measurementId: "G-D38LD15R8P"
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);


export const requestPermission = async () => {
    const permission = await Notification.requestPermission();

    if (permission === "granted") {
        const token = await getToken(messaging, {
            vapidKey: "BJFHCJPHyog30qbcXspGlrbpETw869avpmj3rmF1UV1sIc79ymCAKMmhnZhSdopI5pOkjcBFKi-vYWe6JoO4N8A",
        });

        console.log("FCM Token:", token);
        return token;
    }
};
